/*global angular */

(function (angular) {
'use strict';

var filters = angular.module('cauth.filters', [
    'ngLocale',
    'book.filters',
    'book.services',
    'timeline.services'
]);

filters.filter('momentFormat', [function() {

    return function(date, format) {
        return date.format(format)
    }

}]);

filters.filter('momentDiff', [function() {

    return function(dateEnd, dateStart) {

        if(dateStart === undefined) {
            dateStart = moment().startOf('day');
        }

        var daysDiff = dateEnd.diff(dateStart, 'day');
        daysDiff += 1; // include currrent day

        return daysDiff;
    }

}]);


filters.filter('userBookRQF', ['Url', function(Url) {

    return function(additionalResult, bId) {
    
        if(additionalResult === undefined) {
            return '';
        }

        var items = [];

        if(additionalResult.reviews) {
            var reviews = '<a target="_blank" href="' + Url.bookReviews(bId) + '">Рецензия</a>';
            items.push(reviews);
        }

        if(additionalResult.quotes) {
            var quotes = '<a target="_blank" href="' + Url.bookQuotes(bId) + '">Цитаты</a>';
            items.push(quotes);
        }

        if(additionalResult.facts) {
            var facts = '<a target="_blank" href="' + Url.bookFacts(bId) + '">Факты</a>';
            items.push(facts);
        }

        if(items.length) {
            return 'Добавлено: ' + items.join(', ');
        }
        else {
            return '';
        }
    };

}]);

filters.filter('readDateInterval', ['$filter', '$locale', 'DateDiffInDays', function ($filter, $locale, DateDiffInDays) {

    function capitaliseFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    return function(dates) {

        var date_from = new Date(dates.date_from);
        var date_to = new Date(dates.date_to);

        var days = DateDiffInDays.dateDiffInDays(date_from, date_to);
        if(days === 0) {
            days = 1;
        }
        var daysStr = $filter('rupluralize_with_count')(days, 'день,дня,дней');

        var prefix = '';

        if(date_from.getFullYear() == date_to.getFullYear() && date_from.getMonth() == date_to.getMonth()) {

            var month = capitaliseFirstLetter($locale.DATETIME_FORMATS.SIMPLEMONTH[date_from.getMonth()]);
            prefix = month + ' ' + date_from.getFullYear();

        }
        else {
            var month_from = capitaliseFirstLetter($locale.DATETIME_FORMATS.SIMPLEMONTH[date_from.getMonth()]);
            var month_to = capitaliseFirstLetter($locale.DATETIME_FORMATS.SIMPLEMONTH[date_to.getMonth()]);
            prefix = month_from + ' ' + date_from.getFullYear() + ' - ' + month_to + ' ' + date_to.getFullYear();
        }

        return prefix + ' (' + daysStr + ')';
    };

}]);


}(angular));
